import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Imgcross from '../../assets/img/cross.png';
import OtpInput from 'react-otp-input';
import OtpTimer from 'otp-timer';
import toast, { Toaster } from 'react-hot-toast';
import { internalIpV4 } from '../../services/getIp';

import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";

import { userLogin } from "../../actions/index";
import { connect } from "react-redux";

import { ValidationForm, TextInput, TextInputGroup, FileInput, SelectGroup, Checkbox } from "react-bootstrap4-form-validation";

import validator from 'validator'


import LocalizedStrings from 'react-localization';
import localization from '../../localization';
import eyeSvgrepoCom from "../../assets/img/eye-svgrepo-com.svg";
import eyeOffSvgrepoCom from "../../assets/img/eye-off-svgrepo-com.svg";
let strings = new LocalizedStrings(localization);

const mapStateToProps = state => {
  return { user: state.user };

};

const mapDispatchToProps = dispatch => {
  return {
    userLogin: user => dispatch(userLogin(user))
  };
};

const OtpVerify = (Props) => {

  const [showOtp, setShowOtp] = useState(false);
  const [showOrderSuccess, setShowOrderSuccess] = useState(false);
  const [linkedOrderCount, setLinkedOrderCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const submitLock = useRef(false);
  const resendLock = useRef(false);
  const [getRegister, setRegister] = useState([]);
  const [getOtp, setOtp] = useState({
    otp: '',
    hasErrored: false
  });

  const otpClose = () => setShowOtp(false);
  const successClose = () => window.location.reload();
  const goToOrders = () => {
    window.location.href = '/order';
  };
  useEffect(() => {
    setShowOtp(Props.data);
    setRegister(Props.userData)
  }, [Props]);


  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("current_lang")
      ? localStorage.getItem("current_lang")
      : "en"
  );
  strings.setLanguage(currentLang);
  const handleOtpSubmit = async (e, formData, inputs) => {
    e.preventDefault();
    if (submitLock.current || !validate()) {
      return;
    }

    submitLock.current = true;
    setIsSubmitting(true);
    try {

      let path = apiPath.otpVerify;
      var data = new FormData();
      data.append('email', getRegister.email);
      data.append('otp', getOtp.otp);
      data.append('device_type', 'Website');
      data.append('device_token', await internalIpV4());
      data.append('password', formData.password);
      data.append('confirm_password', formData.confirm_password);
      let options = {
        method: 'POST',
        data: data
      }

      let result = await Http(path, options);
      if (result.status === 200) {
        if (result.data.status) {
          setShowOtp(false);
          Props.userLogin(result.data.data);
          const guestOrdersLinked = Number(result.data.data?.guest_orders_linked || 0);
          if (guestOrdersLinked > 0) {
            setLinkedOrderCount(guestOrdersLinked);
            setShowOrderSuccess(true);
          } else {
            toast.success(result.data.message);
            window.location.reload();
          }
        } else {
          toast.error(result.data.message);
        }
      } else {
        if(result.statusText != null) {
          toast.error(result?.data?.message || result.statusText);
        }
      }
    } finally {
      submitLock.current = false;
      setIsSubmitting(false);
    }
  }


  const validate = () => {
    let isValid = true;
    if (getOtp.otp == null || getOtp.otp === '') {
      toast.error("OTP is required!");
      isValid = false;
    }
    return isValid;
  }


  const handleChange = (value, data, event, formattedValue) => {
    setOtp({ ...getOtp, otp: value });
  }

  const handleResendOtp = async () => {
    if (resendLock.current) {
      return;
    }

    resendLock.current = true;
    setIsResending(true);
    try {
      let path = apiPath.ResendOtp;
      var data = new FormData();
      data.append('email', getRegister.email);
      data.append('device_type', 'Website');
      data.append('device_token', await internalIpV4());
      let options = {
        method: 'POST',
        data: data
      }

      let result = await Http(path, options);
      if (result.status === 200) {
        if (result.data.status) {
          toast.success(result.data.message);
        } else {
          toast.error(result.data.message);
        }
      } else {
        if(result.statusText != null) {
          toast.error(result?.data?.message || result.statusText);
        }
      }
    } finally {
      resendLock.current = false;
      setIsResending(false);
    }
  }






  return (
    <>
      <Modal show={showOtp} onHide={otpClose} animation={true} size="lg" backdrop="static" keyboard={false} centered >
        <Modal.Header >
          <h5 className="modal-title" id="exampleModalLabel">{strings.OTP}</h5>
          <button type="button" className="btn-close" onClick={otpClose}>
            <img src={Imgcross} alt='Close' />
          </button>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <ValidationForm onSubmit={handleOtpSubmit} >
            <div className="popup-cont">

              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label> <h4>{strings.verification_code}</h4></Form.Label>
                <Form.Text className='d-flex mb-3'><p>{strings.which_one_send} "{getRegister ? getRegister.email : ''}" {strings.email}</p></Form.Text>
                <div className="form-group opt_screen">
                  <OtpInput autoFocus required
                    value={getOtp.otp}
                    onChange={handleChange}
                    numInputs={4}
                    hasErrored={getOtp.hasErrored}
                    isInputNum={true}
                    errorMessage={{ required: strings.enter_otp }}
                  />

                </div>
              </Form.Group>
              <Form.Group className="form-group position-relative">
                <Form.Label>Enter Password</Form.Label>
                <TextInputGroup type={showPassword ? 'text' : 'password'} name="password" placeholder="Password" required />
                <div className="input-group-btn passShowHideBtn position-absolute">
                  <img
                    className="w-100"
                    src={showPassword ? eyeOffSvgrepoCom : eyeSvgrepoCom}
                    alt={showPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </Form.Group>
              <Form.Group className="form-group position-relative">
                <Form.Label>Enter Confirm Password</Form.Label>
                <TextInputGroup type={showConfirmPassword ? 'text' : 'password'} name="confirm_password" placeholder="Password" required />
                <div className="input-group-btn passShowHideBtn position-absolute">
                  <img
                    className="w-100"
                    src={showConfirmPassword ? eyeOffSvgrepoCom : eyeSvgrepoCom}
                    alt={showConfirmPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                </div>
              </Form.Group>
              <div className="login-btn">
                <Button type="submit" className="btn btn_primary" disabled={isSubmitting} aria-busy={isSubmitting}>
                  {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                  {strings.continue}
                </Button>
              </div>
              <div className="already_cls">
                <p>{strings.dontReceive_otp} <OtpTimer seconds={60} ButtonText={isResending ? 'Sending...' : 'Resend code'} className="btn btn_primary" minutes={0} resend={handleResendOtp} /></p>
              </div>
            </div>
          </ValidationForm>
        </Modal.Body>
      </Modal>

      <Modal show={showOrderSuccess} onHide={successClose} animation={true} size="sm" backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <h5 className="modal-title">{strings.ordersLinkedTitle}</h5>
          <button type="button" className="btn-close" onClick={successClose} aria-label="Close">
            <img src={Imgcross} alt="Close" />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body order-link-success">
          <span className="order-link-success__icon" aria-hidden="true">
            <i className="fas fa-check"></i>
          </span>
          <p>{strings.ordersLinkedMessage}</p>
          <strong className="order-link-success__count">
            {linkedOrderCount} {linkedOrderCount === 1 ? strings.orderLinked : strings.ordersLinked}
          </strong>
          <Button type="button" className="btn btn_primary" onClick={goToOrders}>
            {strings.goToMyOrders}
          </Button>
        </Modal.Body>
      </Modal>
    </>

  )
}
export default connect(mapStateToProps, mapDispatchToProps)(OtpVerify);
